var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58315 4.02163C1.53469 4.53855 1.50068 5.45337 1.8059 5.84276C1.8059 5.84276 1.66222 4.83782 2.95028 3.57697C3.4689 3.0694 3.58878 2.37904 3.40768 1.86127C3.30481 1.56795 3.11691 1.32564 2.95368 1.15645C2.85845 1.05698 2.93157 0.892888 3.07015 0.898839C3.90845 0.936248 5.26707 1.1692 5.84436 2.61795C6.09772 3.2539 6.11642 3.9111 5.99569 4.57936C5.91918 5.00616 5.64711 5.95498 6.26776 6.07146C6.71071 6.15478 6.92496 5.8028 7.02104 5.54944C7.061 5.44401 7.19958 5.41766 7.2744 5.50183C8.02257 6.35288 8.08634 7.35526 7.9316 8.21822C7.63233 9.88631 5.94298 11.1004 4.26469 11.1004C2.16809 11.1004 0.499146 9.90077 0.0663935 7.72935C-0.107898 6.8528 -0.0194766 5.11839 1.33234 3.8941C1.43267 3.80228 1.59676 3.88389 1.58315 4.02163Z",
    fill: "url(#paint0_radial_563_4089)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_563_4089",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.84943 11.1268) rotate(-179.751) scale(6.00137 9.84705)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#F44336"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.68526c1fa134aad74ac9c089da00e023.svg";
export { ForwardRef as ReactComponent };